import api from "../../axiosconfig";

/**
 * Fetch all organizations with active user counts
 */
export const fetchEmailOrganizations = async () => {
  const response = await api.get("/api/dev/emails/organizations");
  return response.data;
};

/**
 * Resolve recipients for given company IDs and manual emails
 * @param {Object} params - { company_ids: number[], manual_emails: string[] }
 */
export const resolveEmailRecipients = async ({ company_ids = [], manual_emails = [] }) => {
  const response = await api.post("/api/dev/emails/resolve-recipients", {
    company_ids,
    manual_emails,
  });
  return response.data;
};

/**
 * Send broadcast email to organizations and/or manual recipients
 * @param {Object} payload - { subject, body_html, recipient_type, company_ids, manual_emails, sent_by_user_id, sent_by_email }
 */
export const sendEmailBroadcast = async (payload) => {
  const response = await api.post("/api/dev/emails/send", payload);
  return response.data;
};

/**
 * Send a test email to a single test recipient
 * @param {Object} payload - { subject, body_html, test_recipient }
 */
export const sendTestEmail = async (payload) => {
  const response = await api.post("/api/dev/emails/send-test", payload);
  return response.data;
};

/**
 * Fetch sent email history logs
 */
export const fetchSentEmailHistory = async () => {
  const response = await api.get("/api/dev/emails/history");
  return response.data;
};

/**
 * Fetch details for a specific sent email broadcast
 * @param {number|string} emailId
 */
export const fetchSentEmailDetails = async (emailId) => {
  const response = await api.get(`/api/dev/emails/history/${emailId}`);
  return response.data;
};
